export const notePage = (note) => {
	return `/notes/${note.id}`;
};
